module.exports = __webpack_public_path__ + "img/new_43.75816cc9.jpg";